import * as React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const SearchComments = ({ commentData, handleChange }) => (
  <Row>
    <Col>
      <input
        type="search"
        placeholder="Search comments"
        className="form-control"
        aria-label="search for..."
        onChange={(event) => {
          const regExp = new RegExp(event.target.value, "gi");
          const filtered = commentData.filter(
            ({
              snippet: {
                topLevelComment: {
                  snippet: { textOriginal },
                },
              },
            }) => textOriginal.match(regExp)
          );
          handleChange({ filtered, searchTerm: event.target.value });
        }}
      />
    </Col>
  </Row>
);

export default SearchComments;
